import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { CircleSuccessIcon } from '../../../theme/icons'
import ErrorBoundary from '../../../components/Errorboundary'
import SamlError from '../../Error/SamlError'

const SamlConfigTest = React.memo(() => {
    const { formatMessage } = useIntl()
    const [searchParams] = useSearchParams()
    const isSuccess = searchParams.get('success') === 'true'

    if (!isSuccess) {
        return <SamlError />
    }

    return (
        <ErrorBoundary>
            <div className="flex h-screen text-center items-center justify-center mx-8">
                <div>
                    <div className="flex justify-center"><CircleSuccessIcon /></div>
                    <h1 className="font-semibold text-black mt-2">
                        {formatMessage({ id: 'SAML.VERIFICATION.SUCCESS' })}
                    </h1>
                </div>
            </div>
        </ErrorBoundary>
    )
})

export default SamlConfigTest
